<template>
  <thead>
  <tr>
    <th style="width: 11rem">
      <div class="select-dropdown _left">
        <div class="select-dropdown__trigger-wrap">
          <button type="button" class="select-dropdown__trigger"
                  @click.prevent="showFilterDate = true">
            <span>{{ $tAccount('Date') }}</span>
            <BaseSvg v-if="true" class="select-dropdown__trigger-arrow" name="ico-arrow"/>
          </button>
          <div v-if="false" class="select-dropdown__selected">
            <span @click.prevent="showFilterDate = true"
                  class="select-dropdown__selected-text"
            >some {{ $tAccount('and more') }} 5</span>
            <span @click="onClear" class="select-dropdown__selected-del">
              <BaseSvg name="ico-close"/>
            </span>
          </div>
        </div>
        <transition name="dropdown">
          <div
              v-if="showFilterDate"
              v-click-out="() => this.showFilterDate = false"
              class="select-dropdown__dropdown"
          >
            <button
                type="button"
                class="select-dropdown__close"
                @click.prevent="showFilterDate = false"
            >
              <BaseSvg
                  name="ico-close"
                  width=".8rem"
                  height=".8rem"
              />
            </button>

            <div class="select-dropdown__options">
              date
            </div>
          </div>
        </transition>
      </div>
    </th>
    <th style="width: 9rem">
      <AccountTabItemSelectDropdown v-if="filters"
                                    :name="filters.types.name"
                                    filterKey="types"
                                    :values="filters.types.values"
                                    :selectedProperties="filterSelectedProperties['types']"
                                    :isChecked="isChecked"
                                    :onToggleFilter="onToggleFilter"
                                    :onClear="onClear"
                                    class="_left"/>
    </th>
    <th>
      <AccountTabItemSelectDropdown v-if="filters"
                                    :name="filters.operations.name"
                                    filterKey="operations"
                                    :values="filters.operations.values"
                                    :selectedProperties="filterSelectedProperties['operations']"
                                    :isChecked="isChecked"
                                    :onToggleFilter="onToggleFilter"
                                    :onClear="onClear"
                                    class="_left"/>
    </th>
    <th style="width: 17rem">
      <AccountTabItemSelectDropdown v-if="filters"
                                    :name="filters.operation_who.name"
                                    filterKey="operation_who"
                                    :values="filters.operation_who.values"
                                    :selectedProperties="filterSelectedProperties['operation_who']"
                                    :isChecked="isChecked"
                                    :onToggleFilter="onToggleFilter"
                                    :onClear="onClear"/>
    </th>
    <th style="width: 25rem">
      <AccountTabItemSelectDropdown v-if="filters"
                                    :name="filters.partners.name"
                                    filterKey="partners"
                                    :values="filters.partners.values"
                                    :selectedProperties="filterSelectedProperties['partners']"
                                    :isChecked="isChecked"
                                    :onToggleFilter="onToggleFilter"
                                    :onClear="onClear"
                                    :short="false">
        <div class="filter-checkbox__input">
          <BaseInput v-model="partnerSearchValue"
                     :placeholder="$tAccount('Start typing a name')"/>
          <BaseSvg name="ico-loupe"/>
        </div>
        <ul class="filter-checkbox__list">
          <li v-for="item in partnersComputed"
              :key="item.id">
            <BaseCheckbox :label="item.name"
                          :checked="isChecked(['partners', item.id])"
                          @input="onToggleFilter(['partners', item.id])"
                          class="_user">
              <template v-slot:label>
                <span :style="{backgroundImage: `url(${item.avatar})`}"
                      class="checkbox__user-avatar"
                ></span>
                <span class="checkbox__user-name">{{ item.name }}</span>
              </template>
            </BaseCheckbox>
          </li>
        </ul>
      </AccountTabItemSelectDropdown>
    </th>
    <th style="width: 16rem" class="_text-right">
      <div>{{ $tAccount('Sum') }}</div>
    </th>
  </tr>
  </thead>
</template>

<script>
  import AccountTabItemSelectDropdown from './AccountTabItemSelectDropdown'

  export default {
    name: 'AccountTabItemHistoryHeaderDesktop',
    components: {
      AccountTabItemSelectDropdown
    },
    props: {
      filters: Object,
      isChecked: Function,
      onToggleFilter: Function,
      onClear: Function,
      filterSelectedProperties: Object
    },
    data() {
      return {
        partnerSearchValue: null,

        showFilterDate: false,
      }
    },
    computed: {
      partnersComputed() {
        if (!this.filters) return

        let search = this.partnerSearchValue
        if (!search) return this.filters.partners.values

        search = search.toLowerCase()

        return this.filters.partners.values.filter(item => {
          return item.name.toLowerCase().includes(search)
        })
      }
    },
    methods: {
      closeFilterPartners() {
        this.showFilterPartner = false
        this.partnerSearchValue = null
      }
    }
  }
</script>

<style lang="less">

</style>